"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Item;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsby = require("gatsby");

var _classnames = _interopRequireDefault(require("classnames"));

function Item({
  group,
  slug,
  page,
  current,
  rel,
  children
}) {
  let link = "";

  if (group) {
    link += "/" + group;
  }

  if (slug) {
    link += "/" + slug;
  }

  if (page > 1) {
    link += "/" + page;
  }

  return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_gatsby.Link, {
    to: link,
    className: (0, _classnames.default)("pagination-link", {
      "is-current": current === page
    }),
    "aria-label": children || page,
    "aria-current": current === page ? "page" : null,
    rel: rel
  }, children || page));
}

Item.propTypes = {
  group: _propTypes.default.string,
  slug: _propTypes.default.string,
  current: _propTypes.default.number.isRequired,
  page: _propTypes.default.number.isRequired,
  rel: _propTypes.default.string,
  children: _propTypes.default.string
};
Item.defaultProps = {
  current: 0,
  page: 0
};